export const locales = {
  en: {
    translation: {
      name: 'MUSTAFA KAMEL',
      preview:
        'React Native Squad Lead with over 6 years of experience building high-performance mobile applications for trading, fintech, Government ,entertainment, and lifestyle sectors. Proven track record in leading cross-functional teams, collaborating with other teams, and delivering complex features from planning to production. Passionate about performance optimization, clean architecture, and delivering seamless user experiences at scale.',
      showMore: 'Show more',
      showLess: 'Show less',
      experiences: 'Experiences',
      contactMe: 'Contact me',
      experiencesSummary:
        'Here is a summary of my professional experiences over the years:',
      projects: 'Projects',
      projectsSummary:
        'Here is a summary of my professional projects over the years:',
      title: 'Senior/Team Lead React native',
      specialties:
        'Trading, fintech, Government ,entertainment, and e-commerce',
      subtitle:
        'I build scalable, high-performance mobile applications and lead engineering teams delivering production-ready solutions.',
      download: 'Download resume',
      techSkills: 'Technical Skills',
      leadershipSkills: 'Leadership Skills',
      focus_on: 'What is Focus on',
    },
  },
};

export const t = (key: string) => {
  return locales.en.translation[key as keyof typeof locales.en.translation];
};
